import { useTranslation } from 'react-i18next';

import { WrappedErrorBoundary } from '../WrappedErrorBoundary';

function Custom404() {
  const { t } = useTranslation();
  return (
    <div className="not-found-page">
      <div id="background"></div>
      <div className="top">
        <h1>404</h1>
        <h3>{t('site/404/text')}</h3>
      </div>
      <div className="container">
        <div className="ghost">
          <img
            crossOrigin="anonymous"
            src="https://cdn.1cdn.app/application/LOUISEBOT/23091707385795_Logo_colorful.svg"
            width="32px"
            height="32px"
            alt="Page not found"
          />
        </div>

        <div className="shadow"></div>
      </div>
    </div>
  );
}

export default WrappedErrorBoundary(Custom404);
